import { Badge, Text } from "@musa.tech/design-system";
import { COLLECT_STATUS_CONFIG } from "./collectStatus";

interface CollectStatusBadgeProps {
  status: string | null | undefined;
}

export function CollectStatusBadge({ status }: CollectStatusBadgeProps) {
  if (!status) {
    return (
      <Text variant="body" size="small" className="text-neutral-400">
        —
      </Text>
    );
  }

  const config = COLLECT_STATUS_CONFIG[status];
  return (
    <Badge variant={config?.variant ?? 'secondary'} className="whitespace-nowrap">
      {config?.label ?? status}
    </Badge>
  );
}
